import { RequestConfig } from '~/common/services/requests';
import { User } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const getMe = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<User> | undefined> =>
  constructGet<NonPaginatedResponse<User>>(`${AUTH_BASE_PATH}/me`, {
    params,
  });
